"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogFooter = void 0;
var Utilities_1 = require("../../Utilities");
var DialogFooter_base_1 = require("./DialogFooter.base");
var DialogFooter_styles_1 = require("./DialogFooter.styles");
exports.DialogFooter = (0, Utilities_1.styled)(DialogFooter_base_1.DialogFooterBase, DialogFooter_styles_1.getStyles, undefined, { scope: 'DialogFooter' });
exports.DialogFooter.displayName = 'DialogFooter';
//# sourceMappingURL=DialogFooter.js.map